const config = require(`../../../app.config.json`)

export const getCurrentAppConfigApiHost = () => {
  return config.api
}

export const getCurrentAppConfig = () => {
  return config
}
